import React, { useCallback, useMemo, useState } from 'react'
import { Row, Col, Label, Input, Pagination, Table, PaginationItem, PaginationLink, Button } from "reactstrap"

import { ReactComponent as IconoImprimir } from "../../../../assets/icons/HorasExtras/Imprimir.svg"
import { ReactComponent as IconoRegresar } from "../../../../assets/icons/HorasExtras/Reversar.svg"
import { ReactComponent as IconoExcel } from "../../../../assets/icons/HorasExtras/Excel.svg"
import { ESTADO_ENVIADO_A_TH, ESTADO_REVERSADO, ESTADO_SOLICITADO_REVERSO_A_TH, PlanificacionTotal, ReversarUnidadPlanificacion, ReversarUnidadPlanificaciones, UnidadesPlanificacionHEDTO } from './TypesPlanificacionUnidades'

import { ReactComponent as IconoReversar } from "../../../../assets/icons/HorasExtras/Reversar.svg"
import { ReactComponent as IconoNotificacion } from "../../../../assets/icons/HorasExtras/Notificacion.svg"
import { RegimenLaboralHEDTO } from 'components/DirectivoUnidad/Horas Extras/PlanificacionHE/TypesPlanificacionHE'
import { AtenderSolicitudReverso } from '../Proyeccion Horas Extras/TypesProyecionHorasExtrasAdmin'
import { ObtenerReporteExcelPlanificacionesUnidadesTH, ObtenerReportePlanificacionesUnidadesTH, PutAtenderSolicituReverso, PutReversarUnidad, PutReversarUnidades } from './FunctionsPlanificacionUnidades'
import Swal from 'sweetalert2'
import { showAlert } from '../Parametros Horas Extras/Actividades/ActividadesHorasExtras'

import ExitoSVG from "../../../../assets/icons/HorasExtras/Exitosa.svg"
import ErrorSVG from "../../../../assets/icons/HorasExtras/Error.svg"
import ModalReversoHE from 'components/Varios/Modals/ModalReversoHE'
import NumberFormat from 'react-number-format'
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion'

type PropsTablaUnidadesPlanificacionHE = {
    unidadesPlanificacion: UnidadesPlanificacionHEDTO[]
    regimendisponible: RegimenLaboralHEDTO[]
    defaultRowNumber?: number,
    planificacionTotal: PlanificacionTotal
    onActualizarTabla: () => Promise<void>,
    mes: number,
    anio: number
}



type StateModalReversoUnidadTipo = {
    showModal: boolean,
    cargando: boolean,
    planificacionUnidad: UnidadesPlanificacionHEDTO,
    observacion: string
};

type StateModalReversoUnidades = {
    showModal: boolean,
    cargando: boolean,
    planificacionUnidad: UnidadesPlanificacionHEDTO[],
    observacion: string
    content: JSX.Element
};
export default function TablaPlanificacionUnidadesHE(props: PropsTablaUnidadesPlanificacionHE) {


    const defaultStateModalReversoUnidad: StateModalReversoUnidadTipo = {
        showModal: false,
        cargando: false,
        planificacionUnidad: {
            idEstructuraOrganica: 0,
            nombreEstructura: '',
            articuloEstructura: '',
            idPlanificacionUnidad: null,
            detallePlanificacionRegimen: [],
            detalleSolicitudReverso: {
                idSolicitudReverso: 0,
                motivoReverso: '',
                estado: '',
                estadoString: '',
                fechaSolicitud: ''
            },
            presupuestoPlanificado: null,
            presupuestoEjecutado: null,
            presupuestoAsignado: null,
            estado: '',
            estadoString: ''
        },
        observacion: ""
    };

    const defaultStateModalReversoUnidades: StateModalReversoUnidades = {
        showModal: false,
        cargando: false,
        planificacionUnidad: [],
        observacion: "",
        content: <></>
    };


    const [stateModalReversoUnidad, setstateModalReversoUnidad] = useState<StateModalReversoUnidadTipo>(defaultStateModalReversoUnidad)
    const [stateModalReversoUnidades, setstateModalReversoUnidades] = useState<StateModalReversoUnidades>(defaultStateModalReversoUnidades)
    const [observacion, setObservacion] = useState<string>("")
    const [enviarGPE, setenviarGPE] = useState<boolean>(false)
    const [loadingAccion, setloadingAccion] = useState<boolean>(false)

    const [unidadSeleccionada, setunidadSeleccionada] = useState<UnidadesPlanificacionHEDTO | undefined>(undefined)

    const {
        unidadesPlanificacion,
        regimendisponible,
        planificacionTotal
    } = props;

    //PAGES
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(props.defaultRowNumber ?? 5);

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1); // Reiniciar a la primera página al cambiar el número de filas por página
    };
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    //BUSCADOR

    const [searchTerm, setSearchTerm] = useState('');
    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar la paginación cuando se busca
    };

    const filteredServidores = unidadesPlanificacion.filter(unid =>
        unid.nombreEstructura.toLowerCase().includes(searchTerm.toLowerCase())
    );


    const [sortColumn, setSortColumn] = useState<string | null>(null);
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortToggle, setSortToggle] = useState(false);



    let currentRows = filteredServidores.slice(indexOfFirstRow, indexOfLastRow);

    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(filteredServidores.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    }
    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));

    const handleSort = (column: string) => {
        const isAsc = sortColumn === column && sortDirection === 'asc';
        setSortColumn(column);
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortToggle(!sortToggle); // Cambia el estado para forzar re-render
    };



    async function OnClickAccionSolicitudReverso(informacionUnidad: UnidadesPlanificacionHEDTO | undefined) {
        setloadingAccion(true);

        if (!informacionUnidad || !informacionUnidad.detalleSolicitudReverso) {
            setloadingAccion(false);
            await Swal.fire({
                title: 'Advertencia',
                text: 'Información de unidad no válida.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        //const texto = `¿Desea autorizar o negar la solicitud de reverso de ${informacionUnidad.nombreEstructura} ? `
        /*const texto = `<div class="custom-modal-content">
                            <p>¿Desea <b>AUTORIZAR</b> o <b>NEGAR</b> la solicitud de reverso de <br/>${informacionUnidad.nombreEstructura}?</p>
                            <p><b>Motivo:</b> ${informacionUnidad.detalleSolicitudReverso.motivoReverso}</p>
                        </div>`;*/

        const texto = `<div class="custom-modal-content">
            <p>${informacionUnidad.articuloEstructura} <strong>${informacionUnidad.nombreEstructura}</strong> ha solicitado reversar la planificación, por el siguiente motivo:</p>
            <p>${informacionUnidad.detalleSolicitudReverso.motivoReverso}</p>
            
            <p>¿Desea <b>AUTORIZAR</b> o <b>NEGAR</b> la solicitud de reverso?</p>
            
        </div>`;

        const { idSolicitudReverso } = informacionUnidad.detalleSolicitudReverso;

        const result = await Swal.fire({
            html: texto,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Autorizar',
            cancelButtonText: 'Negar',
            reverseButtons: true,
            customClass: {
                cancelButton: 'btn-cancelar',
                confirmButton: 'btn-aceptar',
                popup: 'custom-popup'
            },
        });


        if (result.isConfirmed) {
            await realizarAccionSolicitud(idSolicitudReverso, 1);
        } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
            await realizarAccionSolicitud(idSolicitudReverso, 2);
        } else {
            
            return;
        }
    }

    async function realizarAccionSolicitud(idSolicitudReverso: number, tipoAccion: 1 | 2) {
        try {
            const infoSolicitud: AtenderSolicitudReverso = {
                idSolicitudReverso,
                tipoAccion
            };

            const respuesta = await PutAtenderSolicituReverso(infoSolicitud);

            const textoAutorizacion = tipoAccion === 1 ? "AUTORIZADA" : "NEGADA";

            if (respuesta.status === 200) {
                const mensaje = "La solicitud de reverso de planificación ha sido " + textoAutorizacion
                showAlert(mensaje, true, ExitoSVG)
                await props.onActualizarTabla();

            }
            else {
                const mensaje = "Ha ocurrido un inconveniente al intentar atender el reverso de la unidad"
                showAlert(respuesta.errorMessage ?? mensaje, false, ErrorSVG)
            }
        } catch (error) {
            showAlert('Error al realizar la solicitud.', true, ErrorSVG)
        } finally {
            setloadingAccion(false);
        }
    }



    function AuxiliarGenerarHTMLBodyModalReversarPlanificacion(planificaciones) {

        const contentBody = (
            <>
                <Row>
                    <Col xl={12}>
                        <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                            <thead className="cabecerasDetallehistorialSolic">
                                <tr className="" >
                                    <th> Unidad</th>

                                </tr>
                            </thead>
                            <tbody>
                                {planificaciones.map((planificacion, ind) => {
                                    return (
                                        <tr key={"trMasivoSolicVac" + ind} className="rowHistorialSolicitudVacaciones">
                                            <td className="">
                                                <div className="">
                                                    {planificacion.nombreEstructura}
                                                </div>

                                            </td>

                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row>
                    <Col xl={12}>
                        <Row>
                            <Col xl={12}>
                                <span className={"labelReversoUnidadProyeccion"}> Motivo de reverso</span>

                            </Col>
                            <Col xl={12}>
                                <Input
                                    type="textarea"
                                    name="motivoReversoUnidadProy"
                                    id="motivoReversoUnidadProy"
                                    value={observacion}
                                    onChange={(e) => setObservacion(e.target.value)}
                                />
                            </Col>

                        </Row>
                    </Col>
                </Row>


            </>

        )

        return contentBody;
    }


    async function ReversarPlanificacionUnidad(unidad, observacion) {
        const unidadReverso: ReversarUnidadPlanificacion = {
            planificacionUnidad: unidad,
            motivo: observacion
        }
        const respuesta = await PutReversarUnidad(unidadReverso)

        

        if (respuesta.status !== 200) {
            showAlert(respuesta.errorMessage ?? '', true, ErrorSVG)
            await props.onActualizarTabla();
        }
        else {
            showAlert("Se realizó correctamente el reverso de la planificación de la unidad", true, ExitoSVG)
            await props.onActualizarTabla();
        }
        return 1;
    }

    async function ReversarPlanificacionUnidades(unidad, observacion) {
        const unidadReverso: ReversarUnidadPlanificaciones = {
            planificacionUnidades: unidad,
            motivo: observacion
        }

        const respuesta = await PutReversarUnidades(unidadReverso)
        if (respuesta.status !== 200) {
            showAlert(respuesta.errorMessage ?? '', true, ErrorSVG)
            await props.onActualizarTabla();
        }
        else {
            showAlert("Se realizó correctamente el reverso de todas las planificaciones", true, ExitoSVG)
            await props.onActualizarTabla();
        }
        return 1;
    }

    function OnClickAccionReversarUnidad(planificacionUnidad: UnidadesPlanificacionHEDTO) {
        setstateModalReversoUnidad({
            showModal: true,
            cargando: false,
            planificacionUnidad: planificacionUnidad,
            observacion
        })
    }

    function OnClickAccionReversarUnidades(planificaciones: UnidadesPlanificacionHEDTO[]) {

        var planificacionesUnidades = planificaciones.filter(p => p.detallePlanificacionRegimen.length > 0 && (p.estado === ESTADO_ENVIADO_A_TH || p.estado === ESTADO_SOLICITADO_REVERSO_A_TH))

        var content = AuxiliarGenerarHTMLBodyModalReversarPlanificacion(planificacionesUnidades)
        setstateModalReversoUnidades({
            showModal: true,
            cargando: false,
            planificacionUnidad: planificacionesUnidades,
            observacion,
            content
        })
    }


    async function ReportePDF() {
        setloadingAccion(true)
        await ObtenerReportePlanificacionesUnidadesTH(props.mes, props.anio)
        setloadingAccion(false)
    }

    async function ReporteExcel() {
        setloadingAccion(true)
        await ObtenerReporteExcelPlanificacionesUnidadesTH(props.mes, props.anio)
        setloadingAccion(false)
    }


    function TdAccionUnidad(unid: UnidadesPlanificacionHEDTO) {


        if (unid.detallePlanificacionRegimen.length === 0) {
            return <td />
        }


        var classNameNotificacion = "iconAccionTHUnidProyHidden"
        if (unid.detalleSolicitudReverso !== null) {
            classNameNotificacion = "iconAccionTHUnidProy"
        }



        if (unid.estado.trim() === ESTADO_ENVIADO_A_TH) {
            return (
                <td>
                    <div className='containerAccionesTHUnidProy'>
                        <IconoReversar onClick={() => setunidadSeleccionada(unid)} className="iconAccionTHUnidProy" />
                    </div>
                </td>
            )
        }
        else if (unid.estado.trim() === ESTADO_SOLICITADO_REVERSO_A_TH) {
            return (
                <td>
                    <div className='containerAccionesTHUnidProy'>
                        <IconoNotificacion onClick={() => OnClickAccionSolicitudReverso(unid)} className={"iconAccionTHUnidProy"} />
                    </div>
                </td>
            )
        }
        else {
            return <td><span><strong>{unid.estadoString}</strong></span></td>
        }

    }





    function TBodyTablaProyeccionUnidades(currentRows: UnidadesPlanificacionHEDTO[]) {

        const tbody = currentRows.map((unid, idunid) => {
            const presupuestoPlanificado = unid.presupuestoPlanificado !== null ? unid.presupuestoPlanificado : ""


            if (unid.estado !== ESTADO_ENVIADO_A_TH && unid.estado !== ESTADO_SOLICITADO_REVERSO_A_TH) {
                return (
                    <React.Fragment key={idunid}>
                        <tr className='rows_tabla_planificacion_he rowsProyeccionUnidadesHE'>
                            <td className="tblProyUnidNombUnid">
                                <div>{unid.nombreEstructura}</div>
                            </td>
                            {
                                regimendisponible.map((v, i) => {
                                    return (
                                        <React.Fragment key={v.idRegimenLaboral + "vacioNVProyUnTh"}>
                                            <td />
                                        </React.Fragment>

                                    )
                                })
                            }
                            {
                                regimendisponible.map((v, i) => {
                                    return (
                                        <React.Fragment key={v.idRegimenLaboral + "vacioNVProyUnTh"}>
                                            <td />
                                            <td />
                                            <td />
                                        </React.Fragment>

                                    )
                                })
                            }
                            <td />
                            {
                                TdAccionUnidad(unid)
                            }
                        </tr>
                    </React.Fragment>
                )
            }


            return (
                <React.Fragment key={idunid}>

                    <tr className='rows_tabla_planificacion_he rowsProyeccionUnidadesHE'>
                        <td className="tblProyUnidNombUnid">
                            <div>{unid.nombreEstructura}</div>
                        </td>
                        {
                            unid.detallePlanificacionRegimen.length === 0 && (
                                regimendisponible.map((v, i) => {
                                    return (
                                        <>
                                            <td />
                                            <td />
                                        </>

                                    )
                                })
                            )
                        }

                        {
                            unid.detallePlanificacionRegimen.length > 0 && regimendisponible.map((v, i) => {
                                const numServidoresRegimen = unid.detallePlanificacionRegimen.find(ur => v.idRegimenLaboral === ur.idRegimenLaboral)
                                if (numServidoresRegimen) {
                                    const numServidores = numServidoresRegimen.numPlanifPersona ?? ""

                                    return (
                                        <React.Fragment>
                                            <td className='centrado'>{numServidores}</td>
                                        </React.Fragment>
                                    )
                                }
                                else {
                                    return (
                                        <>
                                            <td />
                                        </>

                                    )
                                }



                            })
                        }

                        {
                            unid.detallePlanificacionRegimen.length > 0 && regimendisponible.map((v, i) => {
                                const horasRegimen = unid.detallePlanificacionRegimen.find(ur => v.idRegimenLaboral === ur.idRegimenLaboral)
                                if (horasRegimen) {
                                    const horasSuplementarias = horasRegimen.horasSuplementarias ?? ""
                                    const horasExtraordinarias = horasRegimen.horasExtraordinarias ?? ""
                                    const presupuesto = horasRegimen.valorTotalPlanificacion !== null ? horasRegimen.valorTotalPlanificacion : ""
                                    return (
                                        <React.Fragment>
                                            <td className='centrado'>{horasSuplementarias}</td>
                                            <td className='centrado'>{horasExtraordinarias}</td>
                                            <td className='centrado'>
                                                <div className='containerValorDineroProyectado'>
                                                    <NumberFormat value={presupuesto} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                                </div>
                                            </td>
                                        </React.Fragment>
                                    )
                                }
                                else {
                                    return (
                                        <>
                                            <td />
                                            <td />
                                            <td />
                                        </>

                                    )
                                }



                            })
                        }
                        <td className='centrado'>
                            <div className='containerValorDineroProyectado'>
                                <NumberFormat value={presupuestoPlanificado} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                            </div>
                        </td>
                        {
                            TdAccionUnidad(unid)
                        }

                    </tr>
                </React.Fragment>
            )
        })

        return tbody;
    }

    function TFooterTablaPlanificacionUnidades(totalPlanificacion: PlanificacionTotal | null) {
        if (totalPlanificacion !== null) {
            return (
                <tr className="trFooterUnidadProyectado">
                    <td className="tblProyUnidNombUnid">
                        <div>
                            PRESUPUESTO PLANIFICADO
                        </div>
                    </td>
                    {
                        totalPlanificacion.valorTotalizadoRegimen.map((v, i) => {
                            const nroSevidores = v.nroServidores ?? ""
                            return (
                                <React.Fragment>
                                    <td key={v.idRegimenLaboral + "tdVacioNro"}> {nroSevidores} </td>

                                </React.Fragment>
                            )
                        })
                    }
                    {
                        totalPlanificacion.valorTotalizadoRegimen.map((v, i) => {
                            const nroHorasExtraor = v.horaExtraordinarias ?? ""
                            const nroHorasSuplementarias = v.horaSuplementarias ?? ""
                            const valorTotal = v.valorHoraTotal ? ("$ " + v.valorHoraTotal?.toFixed(2)) : ""
                            return (
                                <React.Fragment>
                                    <td key={v.idRegimenLaboral + "tdVacioNro"}> {nroHorasSuplementarias} </td>
                                    <td key={v.idRegimenLaboral + "tdVacioNro"}> {nroHorasExtraor} </td>
                                    <td key={v.idRegimenLaboral + "tdVacioNro"}>
                                        <div className='containerValorDineroProyectado'>
                                            {valorTotal}

                                        </div>
                                    </td>

                                </React.Fragment>
                            )
                        })
                    }
                    <td>
                        <div className='containerValorDineroProyectado'>
                            {totalPlanificacion.valorTotalPlanificacion ? ("$ " + totalPlanificacion.valorTotalPlanificacion?.toFixed(2)) : ""}

                        </div>

                    </td>
                    <td />
                </tr>
            )
        }
        else {
            return (
                <tr>
                    <td> PRESUPUESTO PLANIFICADO</td>
                    {
                        props.regimendisponible.map((v, i) => {
                            return (
                                <React.Fragment>
                                    <td key={v.idRegimenLaboral + "tdVacioNro"} />
                                    <td key={v.idRegimenLaboral + "tdVacioValor"} />
                                </React.Fragment>
                            )
                        })
                    }
                    <td colSpan={4} />
                </tr>
            )
        }
    }

    const contenidoModalReversarUnidad = useMemo(
        () => {
            if (unidadSeleccionada !== undefined) {
                return (
                    <React.Fragment>
                        <Row>
                            <Col xl={12}>
                                <Row>
                                    <Col xl={12}>
                                        <span className={"labelReversoUnidadProyeccion"}> Motivo de reverso</span>

                                    </Col>
                                    <Col xl={12}>
                                        <Input
                                            type="textarea"
                                            name="motivoReversoUnidadProy"
                                            id="motivoReversoUnidadProy"
                                            value={observacion}
                                            onChange={(e) => setObservacion(e.target.value)}
                                        />
                                    </Col>

                                </Row>
                            </Col>
                        </Row>

                    </React.Fragment>

                )
            }
            else {
                return (
                    <div> No se ha seleccionado actividad para editar </div>
                )
            }
        },
        [observacion, unidadSeleccionada],
    )

    /*const contenidoModalReversarUnidades = useMemo(
        () => {
            if (unidadSeleccionada !== undefined) {
                return (
                    <React.Fragment>
                        <Row>

                            <Col xl={12}>
                                <Row>
                                    <Col xl={12}>
                                        <span className={"labelReversoUnidadProyeccion"}> Motivo de reverso</span>

                                    </Col>
                                    <Col xl={12}>
                                        <Input
                                            type="textarea"
                                            name="motivoReversoUnidadProy"
                                            id="motivoReversoUnidadProy"
                                            value={observacion}
                                            onChange={(e) => setObservacion(e.target.value)}
                                        />
                                    </Col>

                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                                <thead className="cabecerasDetallehistorialSolic">
                                    <tr className="" >
                                        <th> Unidad</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {planificaciones.map((planificacion, ind) => {
                                        return (
                                            <tr key={"trMasivoSolicVac" + ind} className="rowHistorialSolicitudVacaciones">
                                                <td className="">
                                                    <div className="">
                                                        {planificacion.nombreEstructura}
                                                    </div>

                                                </td>
                                                
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </Row>

                    </React.Fragment>

                )
            }
            else {
                return (
                    <div> No se ha seleccionado actividad para editar </div>
                )
            }
        },
        [observacion, unidadSeleccionada],
    )*/

    const contenidoModalReversarUnidades = useMemo(

        () => {
            if (stateModalReversoUnidades.planificacionUnidad.length > 0) {
                return (
                    <React.Fragment>
                        <Row>

                            <Col xl={12}>
                                <Row>
                                    <Col xl={12}>
                                        <span className={"labelReversoUnidadProyeccion"}> Motivo de reverso</span>

                                    </Col>
                                    <Col xl={12}>
                                        <Input
                                            type="textarea"
                                            name="motivoReversoUnidadProy"
                                            id="motivoReversoUnidadProy"
                                            value={observacion}
                                            onChange={(e) => setObservacion(e.target.value)}
                                        />
                                    </Col>

                                </Row>
                            </Col>
                        </Row>


                    </React.Fragment>

                )
            } else {
                return (
                    <div> No tiene unidades para reversar </div>
                )
            }

        },
        [observacion, stateModalReversoUnidades],
    )

    

    return (
        <React.Fragment>
            <Row className="justify-content-end">
                <Col xl={6}>
                    <div className='containerBotonesTablaProyUnid'>
                        <Button
                            onClick={() => OnClickAccionReversarUnidades(currentRows)}
                            className="btn-white-lightblueborder "
                        >
                            <div className="containerBotonImprimir">
                                <div>Regresar Todas</div>
                                <IconoRegresar className="iconBotonImprimir" />
                            </div>
                        </Button>
                        <Button
                            onClick={() => ReportePDF()}
                            className="btn-white-lightblueborder "
                            disabled={loadingAccion}
                        >
                            <div className="containerBotonImprimir">
                                <div>Imprimir Resumen</div>
                                <IconoImprimir className="iconBotonImprimir" />
                            </div>
                        </Button>



                        <Button
                            disabled={loadingAccion}
                            onClick={() => ReporteExcel()}
                            className="btn-Excel "
                        >
                            <div className="containerBotonImprimir">
                                <div>Exportar a Excel</div>
                                <IconoExcel className="iconBotonImprimir" />
                            </div>
                        </Button>


                    </div>

                </Col>
            </Row>
            <Table responsive bordered className="table_planificacion_he ">
                <thead className="cabeceras_tabla_planificacion_he">
                    <tr className="borde_cabeceras_he">
                        <th className="thUnidad" rowSpan={2} onClick={() => handleSort('nombreEstructura')}>Unidad</th>
                        <th className="thNumServidores" colSpan={2} onClick={() => handleSort('nombreEstructura')}>Número de servidores</th>
                        <th className="thHPlanifLOSEP" colSpan={3} onClick={() => handleSort('nombreEstructura')}>Horas planificadas LOSEP</th>
                        <th className="thHPlanifCT" colSpan={3} onClick={() => handleSort('nombreEstructura')}>Horas planificadas CT</th>
                        <th className="thPresupuestosPlan" rowSpan={2} > {`PRESUPUESTO TOTAL`}</th>
                        <th rowSpan={2} > {`Acciones`}</th>
                    </tr>
                    <tr>
                        {
                            regimendisponible.map((v, i) => {
                                return (
                                    <th> {v.siglasLetrasRegimenLaboral}</th>
                                )
                            })
                        }
                        {
                            regimendisponible.map((v, i) => {
                                return (
                                    <>
                                        <th> H. Suplem</th>
                                        <th> H. Extraor</th>
                                        <th> Presupuesto</th>
                                    </>

                                )
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {TBodyTablaProyeccionUnidades(currentRows)}
                </tbody>
                <tfoot id="footTablaProyeccionUnidadesTH">
                    {TFooterTablaPlanificacionUnidades(props.planificacionTotal)}
                </tfoot>


            </Table>
            <Pagination size="sm" className="pagination_planificacion_he">
                {renderPageNumbers}
            </Pagination>

            <ModalConfirmacion
                idModal='ModalReversoUnidadesTHHE'
                backdrop={false}
                show={unidadSeleccionada !== undefined}
                size='lg'
                centered={true}
                asyncAccion={true}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={true}
                mensajeConfirmacion=''
                nombreBotonAccion='Aceptar'
                classNameBotonAccion='btn-primary-new btnAceptarModalReversoTHHE'
                disabledBotonAccion={!observacion}
                // <Button  className = "btn-primary-new" color="primary" title="Asignar Servidores" onClick={toggleModal}>Asignar a:</Button>
                onClose={() => setunidadSeleccionada(undefined)}
                asyncOnClick={() => ReversarPlanificacionUnidad(unidadSeleccionada, { Observacion: observacion })}
                contentModal={contenidoModalReversarUnidad}
                classNameContentModal='modalContentReversoTHHE'
                tituloModal={"Reverso unidad " + unidadSeleccionada?.nombreEstructura}
                classNametituloModal=''
            />

            <ModalConfirmacion
                idModal='ModalReversoUnidadesTHHE'
                backdrop={false}
                show={(stateModalReversoUnidades.showModal === true) || stateModalReversoUnidades.cargando}
                size='lg'
                centered={true}
                asyncAccion={true}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={true}
                mensajeConfirmacion=''
                nombreBotonAccion='Aceptar'
                classNameBotonAccion='btn-primary-new btnAceptarModalReversoTHHE'
                disabledBotonAccion={!observacion}
                // <Button  className = "btn-primary-new" color="primary" title="Asignar Servidores" onClick={toggleModal}>Asignar a:</Button>
                onClose={() => setstateModalReversoUnidades(defaultStateModalReversoUnidades)}
                asyncOnClick={() => ReversarPlanificacionUnidades(stateModalReversoUnidades.planificacionUnidad, { Observacion: observacion })}
                contentModal={contenidoModalReversarUnidades}
                classNameContentModal='modalContentReversoTHHE'
                tituloModal={"Reversar la planificación de las unidades "}
                classNametituloModal=''
            />
            {/* <ModalReversoHE
                show={(stateModalReversoUnidad.showModal === true ) || stateModalReversoUnidad.cargando}
                size="lg"
                onClose={() => setstateModalReversoUnidad(defaultStateModalReversoUnidad)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea reversar la planificación de esta unidad?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => ReversarPlanificacionUnidad(stateModalReversoUnidad.planificacionUnidad, { Observacion: observacion })}
                contentModal={undefined}
                tituloModal={"Reversar la planificación de la unidad"}
                labelObservacion={"Indique el motivo del reverso"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}
            /> */}
            {/* <ModalReversoHE
                show={(stateModalReversoUnidades.showModal === true ) || stateModalReversoUnidades.cargando}
                size="lg"
                onClose={() => setstateModalReversoUnidades(defaultStateModalReversoUnidades)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea reversar todas las planificaciones?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => ReversarPlanificacionUnidades(stateModalReversoUnidades.planificacionUnidad, { Observacion: observacion })}
                contentModal={stateModalReversoUnidades.content}
                tituloModal={"Reversar la planificación de las unidades"}
                labelObservacion={"Indique el motivo del reverso"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}
                
            /> */}
        </React.Fragment>
    )
}
